import { render, staticRenderFns } from "./EchartsB.vue?vue&type=template&id=4bc80db7&scoped=true&"
import script from "./EchartsB.vue?vue&type=script&lang=ts&"
export * from "./EchartsB.vue?vue&type=script&lang=ts&"
import style0 from "./EchartsB.vue?vue&type=style&index=0&id=4bc80db7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc80db7",
  null
  
)

export default component.exports